var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import jwt_decode from "jwt-decode";
import { parseCognitoGroupToBNRole } from "../api-parsers/parseBNRole";
import { parseAPIUser } from "../api-parsers/parseAPIUser";
export var login = function (bnAPIUrl, username, password) { return __awaiter(void 0, void 0, void 0, function () {
    var res, loginResponse, decodedIDToken, decodedAccessToken, date, authenticatedUser, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "POST",
                        url: bnAPIUrl + "/user/login",
                        data: {
                            email: username,
                            password: password,
                        },
                    })];
            case 1:
                res = _a.sent();
                loginResponse = res.data;
                decodedIDToken = jwt_decode(loginResponse.IdToken);
                decodedAccessToken = jwt_decode(loginResponse.AccessToken);
                date = new Date(0);
                date.setUTCSeconds(decodedAccessToken.exp);
                authenticatedUser = {
                    id: "" + decodedIDToken.email,
                    email: decodedIDToken.email,
                    first_name: decodedIDToken.name,
                    last_name: decodedIDToken.family_name,
                    bn_role: parseCognitoGroupToBNRole(decodedIDToken["cognito:groups"]),
                    last_logged_in: new Date(),
                    confirmed: true,
                    expiration: date,
                    accessToken: loginResponse.AccessToken,
                    refreshToken: loginResponse.RefreshToken,
                    idToken: loginResponse.IdToken,
                };
                return [2, authenticatedUser];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                throw error_1;
            case 3: return [2];
        }
    });
}); };
export var completeRegistration = function (bnAPIUrl, email, code, password, passwordRepeat) { return __awaiter(void 0, void 0, void 0, function () {
    var res, user, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "POST",
                        url: bnAPIUrl + "/user/complete-registration",
                        data: {
                            email: email,
                            confirmation_code: code,
                            password: password,
                            password_confirmation: passwordRepeat,
                        },
                    })];
            case 1:
                res = _a.sent();
                user = parseAPIUser(res.data.user);
                return [2, user];
            case 2:
                error_2 = _a.sent();
                console.error(error_2);
                throw error_2;
            case 3: return [2];
        }
    });
}); };
export var requestPwdResetCode = function (bnAPIUrl, email, recaptcha_token) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "POST",
                        url: bnAPIUrl + "/user/request-password-reset-code",
                        data: {
                            email: email,
                            recaptcha_token: recaptcha_token,
                        },
                    })];
            case 1:
                res = _a.sent();
                return [2, res.data.message === "COMPLETE"];
            case 2:
                error_3 = _a.sent();
                console.error(error_3);
                throw error_3.response.data;
            case 3: return [2];
        }
    });
}); };
export var resetPwdWithCode = function (bnAPIUrl, email, code, password, password_confirmation) { return __awaiter(void 0, void 0, void 0, function () {
    var res, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios({
                        method: "POST",
                        url: bnAPIUrl + "/user/reset-password",
                        data: {
                            email: email,
                            code: code,
                            password: password,
                            password_confirmation: password_confirmation,
                        },
                    })];
            case 1:
                res = _a.sent();
                return [2, res.data.message === "PASSWORD_CHANGED"];
            case 2:
                error_4 = _a.sent();
                console.error(error_4);
                throw error_4.response.data;
            case 3: return [2];
        }
    });
}); };
//# sourceMappingURL=auth.js.map